<template>
  <div class="spaceConfigPainel" data-anima="top">
    <div class="coluna">
      <div class="spaceColor">
        <h1>Integrações</h1>
        <div class="line"></div>
        <div class="subTitle margin-b-title">
          Faça integração com sua plataforma de entrada preferida.
        </div>
        <div class="mt-2">
          <div>
            <b-tabs content-class="mt-3">
              <b-tab title="Tokens" active>
                <h4 class="header">
                  <customIcon class="mr-2" />
                  Tokens
                </h4>
                <div class="create-container">
                  <p class="subTitle">Tokens de acesso para criar integração com <b>entrada</b> de sistemas externos.</p>
                  <b-button class="create-token-button" @click="openIntegration('token')">Criar um novo token</b-button>
                </div>
                <h4 class="header">
                  <customIcon class="mr-2" />
                  Seus tokens de ativos
                </h4>

                <div class="token-container">
                  <table>
                    <tr class="table-header">
                      <th>Nome</th>
                      <th>Token <i class="copy-icon fa-solid fa-copy"></i></th>
                      <th>Expiração</th>
                      <th>Ações</th>
                    </tr>
                    <tr v-for="token in tokens" :key="token.id" class="table-content">
                      <b-tooltip :target="'tooltip-token-' + token.id" triggers="hover">
                        Clique aqui para copiar o token <b>{{ token.name }}</b> !
                      </b-tooltip>
                      <td>{{ token.name }}</td>
                      <td :id="'tooltip-token-' + token.id" class="token-td" @click="copyToken(token.token)">
                        {{ token.token }}
                      </td>
                      <td v-if="token.expire_at">{{ token.expire_at }}</td>
                      <td v-else>Ilimitado</td>
                      <td>
                        <b-button @click="revokeToken(token.id)">Revogar Token</b-button>
                      </td>
                    </tr>
                  </table>
                </div>
              </b-tab>
              <b-tab title="Entrada" v-if="metas.has_external_integrations === 'on'">
                <div>
                  <div>
                    <p class="subTitle">Escolha uma <b>entrada</b> externa para realizar a integração.</p>
                  </div>
                  <ul class="integration-container flex">

                    <li class="integration-item" @click="openIntegration('webhook')">
                      <span style="width: 50px">
                        <svg viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg" fill="none">
                          <g fill="#06c971">
                            <path
                              d="M6.032 4.132c0-1.039.843-1.882 1.886-1.882.709 0 1.328.39 1.65.97a.75.75 0 101.311-.728A3.385 3.385 0 007.918.75a3.383 3.383 0 00-3.386 3.382c0 .94.385 1.79 1.003 2.402l-2.054 3.594a1.25 1.25 0 00.151 2.49h.007a1.25 1.25 0 001.146-1.75l2.369-4.144a.75.75 0 00-.249-1.005 1.879 1.879 0 01-.873-1.587z" />
                            <path
                              d="M7.793 5.375a1.25 1.25 0 01.125-2.494h.006a1.25 1.25 0 011.157 1.725l2.159 3.572a3.383 3.383 0 014.51 3.19 3.383 3.383 0 01-4.23 3.275.75.75 0 11.373-1.452 1.883 1.883 0 002.357-1.822 1.883 1.883 0 00-2.897-1.588.75.75 0 01-1.045-.245l-2.515-4.16z" />
                            <path
                              d="M2.002 10.429a.75.75 0 00-1.298-.752 3.383 3.383 0 002.932 5.073c1.61 0 2.96-1.124 3.301-2.632h4.42c.229.304.592.5 1.001.5h.007a1.25 1.25 0 000-2.5h-.007c-.409 0-.772.197-1 .5H6.271a.75.75 0 00-.75.75 1.883 1.883 0 01-1.886 1.882 1.883 1.883 0 01-1.633-2.821z" />
                          </g>
                        </svg>
                      </span>
                      <b>
                        Webhook
                      </b>
                    </li>

                    <li class="integration-item" @click="openIntegration('hotmart')">
                      <span>
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1003.08 321.74">
                          <title>hotmart-42</title>
                          <path
                            d="M287.06,603.64V458.7a1.23,1.23,0,0,1,1.3-1.3h27.89a1.4,1.4,0,0,1,1.31,1.3v52.4h.52c7.3-9.38,18.5-13.56,30.76-13.56,21.89,0,28.93,14.34,28.93,33.37v73a1.39,1.39,0,0,1-1.3,1.3H348.58a1.23,1.23,0,0,1-1.31-1.3V533.52c0-8.34-8.6-10.69-14.07-10.69s-15.64,3.65-15.64,13.82v67a1.4,1.4,0,0,1-1.31,1.3H288.36a1.39,1.39,0,0,1-1.3-1.3ZM509.41,575V525.18H496.64a1.24,1.24,0,0,1-1.31-1.31v-18c0-.53.53-1.05.79-1.31.52-.26,16.94-4.95,16.94-4.95s8.86-28.15,9.12-28.67a1.22,1.22,0,0,1,1.31-.79h15.12a1.24,1.24,0,0,1,1.3,1.31v28.15h22.42a1.39,1.39,0,0,1,1.3,1.3v22.94a1.4,1.4,0,0,1-1.3,1.31H539.91V572.1c0,4.95,2.87,7.82,9.38,7.82h13a1.39,1.39,0,0,1,1.3,1.3v20.07a1.62,1.62,0,0,1-.78,1.31c-7.82,2.86-12.25,4.69-21.38,4.69C518.8,607,509.41,593.73,509.41,575Zm436.37,0V525.18H933a1.24,1.24,0,0,1-1.31-1.31v-18a2.17,2.17,0,0,1,.79-1.31c.52-.26,16.94-4.95,16.94-4.95s8.86-28.15,9.12-28.67a1.2,1.2,0,0,1,1.31-.79H975a1.24,1.24,0,0,1,1.3,1.31v28.15H998.7a1.39,1.39,0,0,1,1.3,1.3v22.94a1.4,1.4,0,0,1-1.3,1.31H976.28V572.1c0,4.95,2.87,7.82,9.38,7.82h13a1.39,1.39,0,0,1,1.3,1.3v20.07a1.62,1.62,0,0,1-.78,1.31c-7.82,2.86-12.25,4.69-21.38,4.69C954.9,607,945.78,593.73,945.78,575ZM582.14,603.64v-103a1.23,1.23,0,0,1,1.3-1.3h25.29a1.73,1.73,0,0,1,1.3,1c0,.52,2.87,10.43,2.87,10.43h.52c7.3-9.39,18.25-13.56,30.5-13.56,14.86,0,22.16,6.78,26.33,17.21H671c7.56-12.77,20.85-17.21,33.1-17.21,21.9,0,28.94,14.34,28.94,33.37v73a1.23,1.23,0,0,1-1.3,1.3h-27.9a1.39,1.39,0,0,1-1.3-1.3V533.78c0-8.34-7.82-11.47-13.29-11.47-6.26,0-15.9,3.91-16.17,13.29v67.78a1.39,1.39,0,0,1-1.3,1.3H643.66a1.23,1.23,0,0,1-1.3-1.3V533.52c0-8.34-8.35-11.47-14.34-11.47-5.48,0-15.12,4.17-15.12,14.6v66.73a1.23,1.23,0,0,1-1.3,1.3H583.7a1.17,1.17,0,0,1-1.56-1Zm169.18-80.81v-19a1.19,1.19,0,0,1,1-1.3c14.6-2.87,27.89-5,40.66-5,27.11,0,42.76,6.52,42.76,35.72V603.9a1.24,1.24,0,0,1-1.31,1.3H807.88c-.78,0-1-.52-1.3-1s-2.87-10.43-2.87-10.43H805c-7.56,10.43-17.73,13.56-30,13.56-19.81,0-30.5-15.38-30.5-33.63,0-27.37,20.07-32.84,34.93-32.84h25.81v-7c0-8.6-6.52-10.43-31-10.43-10.43,0-21.38.78-21.9.78a1.83,1.83,0,0,1-1-1.3Zm54.22,36.49H788.85c-8.86,0-14.59,3.39-14.59,12.78,0,10.16,7.3,12.51,14.33,12.51,6.52,0,16.95-3.91,16.95-16.94Zm48.22,44.32v-103a1.23,1.23,0,0,1,1.31-1.3h25a1.19,1.19,0,0,1,1.3,1c0,.52,2.87,15.9,2.87,15.9h.52c6.78-13.81,20.6-18.77,32.59-19.29a1.23,1.23,0,0,1,1.3,1.31V527a1.39,1.39,0,0,1-1.3,1.3h-7c-19.29,0-25.81,7.56-25.81,17.21v57.87a1.39,1.39,0,0,1-1.3,1.3H855.33A1.15,1.15,0,0,1,853.76,603.64Zm-463-51.35c0-33.63,13-54.75,50.31-54.75s50.58,21.38,50.58,54.75c0,33.62-13,54.74-50.58,54.74C403.84,607,390.8,585.91,390.8,552.29Zm32.85,0c0,18.24,2.61,29.19,17.2,29.19,14.86,0,17.47-11.21,17.47-29.19,0-18.25-2.61-29.2-17.47-29.2C426.52,523.09,423.65,534,423.65,552.29Z"
                            transform="translate(3.08 -336.64)" fill="#053d4e" />
                          <path
                            d="M230,541.86c1.56-28.67-8.34-75.6-32.32-114.18a.83.83,0,1,0-1.57.53c1.57,5.73,2.09,16.42-7.3,15.9-16.42-1.05.52-36.5-35.71-60.74a.87.87,0,0,0-1.3,1c2.6,4.69,3.91,19.55-1.83,24.51-4.69,3.91-13,2.86-21.11-10.43-13.56-22.16-8.34-45.62.78-60.48.78-1-.26-1.56-1-1.3-49.79,16.42-59.7,75.07-70.39,96.45-1.82,3.65-3.38,5.47-6.25,5.21-9.13-.52-2.61-20.07.52-26.59.52-1-.52-1.56-1.3-.78C25.6,437.59,2.4,483.21-2,525.44c.26-1.05-.52,3.39-.78,6.77,0,1.31-.26,2.61-.26,3.91v4.7a116.52,116.52,0,1,0,233,2.08Zm-117,54a54,54,0,1,1,54.48-53.44A53.9,53.9,0,0,1,112.93,595.82Z"
                            transform="translate(3.08 -336.64)" fill="#f04e23" />
                        </svg>
                      </span>
                      <b>
                        Hotmart
                      </b>
                    </li>

                    <li class="integration-item" @click="openIntegration('eduzz')">
                      <span style="top: 6px;">
                        <svg version="1.1" viewBox="0 0 161.19 45" xmlns="http://www.w3.org/2000/svg"
                          class="w-auto h-8 sm:h-10">
                          <defs>
                            <clipPath id="a">
                              <path d="m0 1080h1920v-1080h-1920z"></path>
                            </clipPath>
                          </defs>
                          <g transform="matrix(1.3333 0 0 -1.3333 -705.6 880.36)">
                            <g transform="matrix(.14031 0 0 .14031 454.95 567.63)">
                              <g clip-path="url(#a)">
                                <g transform="translate(896.64 550.63)">
                                  <path
                                    d="m0 0h-54.287v5.801c0 15.316 9.043 22.969 26.917 22.969 18.327 0 27.37-7.653 27.37-22.969zm-26.675 49.424c-34.339 0-51.508-16.706-51.508-50.35v-20.191c0-34.57 17.864-49.655 57.076-49.655 11.138 0 21.107 1.168 30.16 3.716 8.116 2.084 9.516 3.716 9.516 11.369v3.021c0 8.117-2.094 9.969-9.516 8.117-10.443-2.548-20.422-3.716-30.16-3.716-23.443 0-33.18 6.737-33.18 23.674v5.096h64.498c8.59 0 10.906 2.094 11.832 10.674 0.232 4.642 0.464 8.126 0.464 10.211 0 31.559-16.938 48.034-49.182 48.034"
                                    fill="#0d2772"></path>
                                </g>
                                <g transform="translate(1020.6 529.98)">
                                  <path
                                    d="m0 0c0-19.717-7.19-27.612-29.465-27.612s-29.002 7.432-29.002 27.612v19.959c0 20.18 6.959 27.843 29.002 27.843s29.465-7.663 29.465-27.843zm13.232 114.86h-2.79c-8.348 0-10.442-2.094-10.442-10.442v-49.424c-6.264 9.98-17.633 15.085-33.876 15.085-32.244 0-48.487-16.938-48.487-50.582v-19.958c0-33.181 17.633-49.655 53.13-49.655 34.107 0 52.897 16.937 52.897 49.655v104.88c0 8.348-2.084 10.442-10.432 10.442"
                                    fill="#0d2772"></path>
                                </g>
                                <g transform="translate(1157 597.49)">
                                  <path
                                    d="m0 0h-3.021c-8.348 0-10.432-2.084-10.432-10.443v-61.95c0-16.475-6.264-22.738-26.454-22.738-20.191 0-26.686 6.263-26.686 22.738v61.95c0 8.359-2.084 10.443-10.443 10.443h-3.011c-8.358 0-10.442-2.084-10.442-10.443v-61.95c0-30.16 16.938-45.245 50.582-45.245 34.57 0 50.35 14.854 50.35 45.245v61.95c0 8.359-2.085 10.443-10.443 10.443"
                                    fill="#0d2772"></path>
                                </g>
                                <g transform="translate(1269.9 503.99)">
                                  <path
                                    d="m0 0h-57.54c-4.874 0-7.422 1.39-7.422 4.169 0 2.095 1.621 4.179 4.864 6.274l51.518 31.318c7.19 4.41 11.833 8.357 14.149 12.295 2.557 3.947 3.716 9.284 3.716 15.548 0 17.401-7.201 23.896-26.918 23.896h-53.371c-7.421 0-9.274-1.853-9.274-9.274v-3.021c0-7.422 1.853-9.285 9.274-9.285h51.055c4.864 0 7.422-1.39 7.422-3.937 0-1.863-1.853-4.18-5.569-6.727l-51.045-31.328c-11.832-7.19-17.632-16.475-17.632-27.843 0-15.78 8.811-23.665 26.675-23.665h60.098c7.421 0 9.285 1.853 9.285 9.275v3.021c0 7.421-1.864 9.284-9.285 9.284"
                                    fill="#0d2772"></path>
                                </g>
                                <g transform="translate(1381.5 503.99)">
                                  <path
                                    d="m0 0h-57.54c-4.874 0-7.432 1.39-7.432 4.169 0 2.095 1.632 4.179 4.874 6.274l51.508 31.318c7.2 4.41 11.833 8.357 14.159 12.295 2.548 3.947 3.706 9.284 3.706 15.548 0 17.401-7.19 23.896-26.908 23.896h-53.371c-7.421 0-9.274-1.853-9.274-9.274v-3.021c0-7.422 1.853-9.285 9.274-9.285h51.045c4.874 0 7.432-1.39 7.432-3.937 0-1.863-1.863-4.18-5.569-6.727l-51.045-31.328c-11.842-7.19-17.642-16.475-17.642-27.843 0-15.78 8.821-23.665 26.685-23.665h60.098c7.422 0 9.275 1.853 9.275 9.275v3.021c0 7.421-1.853 9.284-9.275 9.284"
                                    fill="#0d2772"></path>
                                </g>
                                <g transform="translate(768.11 539.99)">
                                  <path
                                    d="m0 0c0-66.432-53.844-120.27-120.28-120.27-35.547 0-67.479 15.447-89.503 39.968h69.453c11.067 0 20.05 8.982 20.05 20.05 0 11.177-8.983 20.159-20.05 20.159h-93.399c-0.071 0.182-0.131 0.373-0.191 0.575-2.115 6.223-3.787 12.748-4.995 19.475h52.636c11.057 0 20.039 8.982 20.039 20.039 0 11.067-8.982 20.05-20.039 20.05h-52.636c1.188 6.686 2.87 13.282 5.045 19.475 0.061 0.181 0.131 0.373 0.201 0.564h93.339c11.067 0 20.05 8.982 20.05 20.049 0 11.057-8.983 20.04-20.05 20.04h-69.573c7.925 8.821 17.109 16.474 27.279 22.657 18.187 11.067 39.525 17.441 62.344 17.441 66.432 0 120.28-53.834 120.28-120.28"
                                    fill="#ffbc00"></path>
                                </g>
                              </g>
                            </g>
                          </g>
                        </svg>
                      </span>
                      <b>
                        Eduzz
                      </b>
                    </li>
                  </ul>
                </div>
              </b-tab>
              <b-tab title="Saída">
                <div>
                  <div>
                    <p class="subTitle">Escolha uma <b>saída</b> para realizar a integração.</p>
                  </div>
                  <ul class="integration-container flex">
                    <li class="integration-item"  @click="openIntegration('gdigital')">
                      <span style="top: 6px;">
                        <img v-if="theme === 'dark'" src="../../assets/img/GREENN_SALES_WHITE.png" alt="G Digital">
                        <img v-else src="../../assets/img/GREENN_SALES_BLACK.png" alt="G Digital">
                      </span>
                      <b>
                        Greenn Sales
                      </b>
                    </li>
                  </ul>
                </div>
              </b-tab>
            </b-tabs>
          </div>
        </div>
      </div>
    </div>

    <ModalIntegrationEduzz :tokens="tokens" />
    <ModalIntegrationHotmart :tokens="tokens" />
    <ModalIntegrationWebhook :tokens="tokens" />
    <ModalIntegrationCreateToken @refresh-tokens="getTokens" />
    <ModalIntegrationRevokeToken @refresh-tokens="getTokens" :token-id="token_revoke" />
    <ModalNewGDigital/>
    <ModalIntegrationGDigital/>

  </div>
</template>

<script>
import customIcon from "./icons/custom.vue";
import TokenService from "@/services/resources/TokenService";

const serviceToken = TokenService.build();

import ModalIntegrationGDigital from "@/components/ModalIntegrationGDigital.vue";
import ModalIntegrationEduzz from "@/components/ModalIntegrationEduzz.vue";
import ModalIntegrationHotmart from "@/components/ModalIntegrationHotmart.vue";
import ModalIntegrationWebhook from "@/components/ModalIntegrationWebhook.vue";
import ModalIntegrationRevokeToken from "@/components/ModalIntegrationRevokeToken.vue";
import ModalIntegrationCreateToken from "@/components/ModalIntegrationCreateToken.vue";

import ModalNewGDigital from "@/components/ModalNewGDigital.vue";

export default {
  data() {
    return {
      browserApi: false,
      modal_selected: false,
      token_revoke: false,
      tokens: null,
      metas: {}
    }
  },
  components: {
    ModalIntegrationEduzz,
    ModalIntegrationGDigital,
    ModalIntegrationHotmart,
    ModalIntegrationWebhook,
    ModalIntegrationRevokeToken,
    ModalIntegrationCreateToken,
    customIcon,
    ModalNewGDigital
  },
  async mounted() {
    this.browserApi = navigator;
    await this.getTokens();
    await this.getMetas();
    if(this.$route.query.globalToken != undefined){
      this.$bvModal.show('modal-gdigital');
      this.$bvModal.show('modal-integration-gdigital');
      this.$bvModal.show('modal-newgdigital');
    }
  },
  computed: {
    theme() {
            return this.$store.state.globalSettings.theme;
        },
        themeIsDark() {
            return this.theme === 'dark';
        },
        themeIsLight() {
            return this.theme === 'light';
        }
  },
  methods: {
    async getTokens() {
      await serviceToken
        .read("/")
        .then((resp) => {
          this.tokens = resp;
        });
    },
    async getMetas(){
      let resp = await this.$store.dispatch("fetchMetas", [
        "has_external_integrations"
      ])
      this.metas = resp;
    },
    copyToken(token) {
      this.browserApi.clipboard.writeText(token);
    },
    revokeToken(token) {
      this.token_revoke = token;
      this.$root.$emit("bv::show::modal", "modal-integration-revoke-token", "#btnShow");
    },
    openIntegration(type) {
      switch (type) {
        case 'webhook':
          this.modal_selected = type;
          this.$root.$emit("bv::show::modal", "modal-integration-webhook", "#btnShow");
          break;
        case 'eduzz':
          this.modal_selected = type;
          this.$root.$emit("bv::show::modal", "modal-integration-eduzz", "#btnShow");
          break;
        case 'hotmart':
          this.modal_selected = type;
          this.$root.$emit("bv::show::modal", "modal-integration-hotmart", "#btnShow");
        break;
        case 'gdigital':
          this.modal_selected = type;
          this.$root.$emit("bv::show::modal", "modal-integration-gdigital", "#btnShow");
        break;
        case 'token':
          this.modal_selected = type;
          this.$root.$emit("bv::show::modal", "modal-integration-create-token", "#btnShow");
          break;
      }
    },
  }
}
</script>

<style>
.nav-tabs .nav-link.active,
.nav-tabs .nav-item.show .nav-link {
  background-color: var(--backgroundcolor);
}
</style>

<style lang="scss" scoped>
.token-td {
  cursor: pointer;
}

.copy-icon {
  font-size: 25px;
  position: relative;
  top: 4px;
}

.create-container {
  display: block;
  margin-bottom: 30px;
}

.webhook {
  font-size: 40px;
}

.create-token-button {
  background: var(--maincolor);
  border: 0px;
  max-height: 40px;
  font-size: 1rem;
  margin-bottom: 30px;
}

.margin-b-title {
  margin-bottom: 50px;
}

.header {
  font-size: 1.1rem !important;
  color: var(--fontcolor);
}

.table-header {
  color: var(--fontcolor);
}

.table-content {
  color: var(--fontcolor2);
}

.token-container table {
  width: 90%;
  border-collapse: collapse;

}

.token-container table tr::before {
  height: 3em;
  display: table-row;
  content: '';
}

.token-container table tr td button {
  background: var(--maincolor);
  border: 0px;
  max-height: 40px;
  font-size: 10px;
}

.integration-container {
  list-style-type: none;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: flex-start;
}

.integration-container .integration-item {
  width: 130px;
  height: 130px;
  background: transparent;
  border-radius: 10px;
  margin: 10px 10px;
  position: relative;
  border: 1px solid var(--fontcolor);
  transition: transform .2s;
}

.integration-container .integration-item:hover {
  transform: scale(1.2);
  cursor: pointer;
}


.integration-container .integration-item b {
  position: absolute;
  bottom: 10px;
  text-align: center;
  width: 100%;
  color: var(--maincolor);
  font-weight: 500;
}

.integration-container .integration-item span {
  display: block;
  position: relative;
  width: 110px;
  height: auto;
  border: none;
  margin: 0 auto;
  margin-top: 35px;
  text-align: center;
}

h1 {
  font-weight: 600;
  font-size: 24px;
  line-height: 29px;
  display: flex;
  align-items: center;
  color: var(--fontcolor);
  margin-bottom: 15px;
}

.line {
  width: 100%;
  height: 1px;
  background: #ededf0;
  margin-bottom: 15px;
}

.coluna {
  width: 100%;
  padding-left: 10px;
}

.spaceColor {
  margin-top: 20px;
  margin-bottom: 20px;

  .text {
    font-family: Montserrat;
    font-style: normal;
    font-weight: 600;
    font-size: 13px;
    color: var(--fontcolor2);
    margin-bottom: 5px;
  }

  .text2 {
    font-family: Montserrat;
    font-style: normal;
    font-weight: 600;
    font-size: 14px;
    color: var(--fontcolor2);
    margin-bottom: 5px;
  }
}

.textTitle {
  font-family: Montserrat;
  font-style: normal;
  font-weight: 600;
  font-size: 16px;
  color: var(--fontcolor);
  display: flex;
}

.subTitle {
  font-family: Montserrat;
  font-style: normal;
  font-weight: normal;
  font-size: 1rem;
  letter-spacing: 0.2px;
  color: #81858e;
}

.flex {
  display: flex;
}
</style>